// ** React Imports
import { useEffect, useState } from 'react'

import { client } from 'src/utils/axios-client';
import { LeadScreenStore, LeadActivity, Lead, NextActivity, LeadAccountStore, ViewType, ActivityDialogStore, LeadCompanyStore, CompanyDialogStore, IncomingCallPopupStore, LeadSearchStore, InboundCallStore, LeadListStore, ReferralSearchStore } from 'src/stores/LeadStore';
// ** MUI Imports
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Tooltip from '@mui/material/Tooltip'
import Grid from '@mui/material/Grid'
import _ from 'lodash';
import Badge, { BadgeProps } from '@mui/material/Badge';
import LocalFireDepartmentTwoTone from '@mui/icons-material/LocalFireDepartmentTwoTone';
import QuestionAnswerTwoToneIcon from '@mui/icons-material/QuestionAnswerTwoTone';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import { getLeadEndpoint, leadEndpoints } from '../../../configs/endpoints';
import LeadDataFormater from './LeadDataFormater';
import { ProblemDetails } from '../../../types/ApiErrorResponse';

type Props = {
    lead: Lead
}

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
    '& .MuiBadge-badge': {
        right: 33,
        top: 10,
        border: `2px solid ${theme.palette.background.paper}`,
        padding: '0 4px',
    },
}));



const LeadReferralSearch = ({ lead }: Props) => {
    const leadsRecord = LeadSearchStore.useState(s => s.record);
    var leads = LeadSearchStore.useState(s => s.record.matchedLeads);
    const [dataLoaded, setDataLoaded] = useState(true);
    const [machedFoundText, setMachedFoundText] = useState('matching lead found');
    const [showSearch, setShowSearch] = useState(true);
    const [searchBoxValue, setSearchBoxValue] = useState('');
    const [selectButtonDisabled, setSelectButtonDisabled] = useState(false);
    const [logActivityButtonText, setLogActivityButtonText] = useState('Select');
    const referralSearch = ReferralSearchStore.useState(s => s);

    const [searchString, setSearchString] = useState('');
    

    useEffect(() => {
        const fetchLeadDetails = async () => {
            //setDataLoaded(false);
            const response = await client.get(leadEndpoints.referralleadsearch.replace('{customerid}/{searchstring}', lead.customer.id + '/' + searchString));
            LeadSearchStore.update(s => { s.record = response.data });
            switch (response.data.leadCount) {
                case 0:
                    setMachedFoundText('matching leads found');
                    setShowSearch(true);
                    break;
                case 1:
                    setMachedFoundText('matching lead found');
                    //setShowSearch(false);
                    break;
                default:
                    setMachedFoundText('matching leads found');
                //setShowSearch(false);
            }
            //setDataLoaded(true);
            
        }
        if (searchString != "") fetchLeadDetails();
    }, [searchString])

    useEffect(() => {
        const updateReferral = async () => {
            await client.post(leadEndpoints.assignreferralsearchlead, referralSearch)
                .then(async (response) => {

                    LeadScreenStore.update(s => { s.isAddReferralPopup = false })

                }).catch((err: ProblemDetails) => {
                    if (err.errors) {
                        for (const [key, value] of Object.entries(err.errors)) {
                            var errorMessage = '';

                            value.forEach((message) => {
                                message += message + '\\'
                            });

                        }
                    }
                });
        }
        if (referralSearch.referralFromId != "") updateReferral();
    }, [referralSearch])

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchBoxValue(event.target.value);
        handleSearchClick2(event.target.value);
    };

    const handleSearchClick2 = (searchString: string) => {
        if (searchString == "") {
            setSearchString("DONOTSEARCH");
        }
        else {
            setSearchString(searchString);
        }
    };

    const handleSearchClick = () => {
        if (searchBoxValue == "") {
            setSearchString("DONOTSEARCH");
        }
        else {
            setSearchString(searchBoxValue);
        }
    };

    const handleMouseDownSearch = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        
    };


    const handleSelectedClick = (leadId: string) => {
        setLogActivityButtonText("Please wait..");
        setSelectButtonDisabled(true);

        ReferralSearchStore.update(s => { s.referralFromId = lead.id; s.selectedLeadId = leadId })

        
    };

    if (dataLoaded) {
        return (
            <Box sx={{ width: 700 }}>
                <div>{leadsRecord.leadCount} {machedFoundText}</div>
                <br />
                {showSearch &&
                    <FormControl fullWidth variant="outlined">
                        <InputLabel htmlFor="outlined-adornment-password">Search by lead name</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-password"
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={handleSearchClick}
                                        edge="end"
                                        onMouseDown={handleMouseDownSearch}
                                    >
                                        <SearchIcon />
                                    </IconButton>
                                </InputAdornment>
                            }
                            label="Search by lead name"
                            size="small"
                            onChange={handleSearchChange}
                            value={searchBoxValue}
                        />
                    </FormControl>
                }

                <Divider />
                {leads.map(record => (
                    <Card sx={{ mb: 6 }} data-testid="activity-timeline" key={record.leadId}>
                        <CardContent sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                            <Grid container spacing={2} justifyContent={'center'} alignItems={'center'}>
                                <Grid item xs={5} justifyContent={'center'} alignItems={'center'} sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                    <Grid item xs={12} justifyContent={'center'} alignItems={'center'} sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                        <Typography variant='h6'>
                                            {record.leadName}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} justifyContent={'center'} alignItems={'center'} sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                        <LeadDataFormater labelText='' valueText={record.jobTitle} textColor='CornflowerBlue' errorText='-Job Title is missing-' chipHeight={20} chipFontSize='0.875rem' chipfontWeight={500} isChip={false} />
                                        {record.company != null &&
                                            <LeadDataFormater labelText='at' valueText={record.company} textColor='CornflowerBlue' errorText='-Company is missing-' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                                        }
                                    </Grid>
                                    <Grid item xs={12} justifyContent={'center'} alignItems={'center'} sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'right' }}>
                                            {record.isHot &&
                                                <Tooltip title="Is a Hot Lead">
                                                    <LocalFireDepartmentTwoTone sx={{ color: 'FireBrick' }} />
                                                </Tooltip>
                                            }
                                            {record.hasMI &&
                                                <Tooltip title="Has a Meaningful Interaction">
                                                    <QuestionAnswerTwoToneIcon sx={{ color: 'LightSeaGreen' }} />
                                                </Tooltip>
                                            }
                                        </Box>
                                    </Grid>
                                </Grid>
                                <Grid item xs={5} justifyContent={'center'} alignItems={'center'} sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                    <Grid item xs={12} justifyContent={'center'} alignItems={'center'} sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'right' }}>
                                            <LeadDataFormater labelText='' valueText={record.stageName} textColor={record.stageColor} errorText='-Not Set-' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={true} />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} justifyContent={'center'} alignItems={'center'} sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'right' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                {record.country != '' &&
                                                    <Tooltip title="Country" >
                                                        <Typography variant="caption" >{record.country}</Typography>
                                                    </Tooltip>
                                                }
                                                {record.country == '' &&
                                                    <Tooltip title="Country" >
                                                        <Typography variant="caption" >-Country Not Assigned-</Typography>
                                                    </Tooltip>
                                                }
                                            </Box>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} justifyContent={'center'} alignItems={'center'} sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'right' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                {record.leadOwnerName != '' &&
                                                    <Tooltip title="Primary lead owner" >
                                                        <Typography variant="caption" sx={{ fontStyle: 'italic' }} >Owner: {record.leadOwnerName}</Typography>
                                                    </Tooltip>
                                                }
                                                {record.leadOwnerName == '' &&
                                                    <Tooltip title="Primary lead owner" >
                                                        <Typography variant="caption" sx={{ fontStyle: 'italic' }} >Owner: -Not Assigned-</Typography>
                                                    </Tooltip>
                                                }
                                            </Box>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} justifyContent={'center'} alignItems={'center'} sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'right' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                {record.sprintName != '' &&
                                                    <Tooltip title="Primary lead owner" >
                                                        <Typography variant="caption" sx={{ fontStyle: 'italic' }} >Sprint: {record.sprintName}</Typography>
                                                    </Tooltip>
                                                }
                                                {record.sprintName == '' &&
                                                    <Tooltip title="Primary lead owner" >
                                                        <Typography variant="caption" sx={{ fontStyle: 'italic' }} >Sprint: -Not Assigned-</Typography>
                                                    </Tooltip>
                                                }
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>
                                <Grid item xs={2} justifyContent={'center'} alignItems={'center'} sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                    <Tooltip title="Select referral" >
                                        <Button size='small' disabled={selectButtonDisabled} variant="outlined" color="info" startIcon={<DoneOutlineIcon />} sx={{ mr: 3 }} onClick={() => handleSelectedClick(record.leadId)} >
                                            {logActivityButtonText}
                                        </Button>
                                    </Tooltip>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                ))
                }
            </Box>
        )
    }
    else {
        return <Box>Searching for matching leads...</Box>
    }

}

export { LeadReferralSearch }

export default LeadReferralSearch;